import { render } from "./OapMikMak.vue?vue&type=template&id=23df6022"
import script from "./OapMikMak.vue?vue&type=script&lang=js"
export * from "./OapMikMak.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__